import React from 'react';
import { getCtaColorClasses } from './getCtaColorClasses.ts';
export const CTAButton = ({ style, url, label, target, colorUnderTheButton, className = '' }) => {
    if (!url) {
        return null;
    }
    const colorClasses = getCtaColorClasses(style, colorUnderTheButton);
    return (React.createElement("a", { className: `self-start text-base px-4 py-3 font-medium mt-8 cursor-pointer no-underline duration-200 ${className} ${colorClasses}`, href: url, target: target }, label));
};
